module.exports = __webpack_public_path__ + "img/26.421681a.jpg";